import { useId, useState } from "react";
import { Pencil } from "lucide-react";

export function EditableName({ value, label, onSave }: { value: string; label: string; onSave: (value: string) => Promise<void> }) {
  const id = useId();
  const [editing, setEditing] = useState(false), [draft, setDraft] = useState(value), [busy, setBusy] = useState(false), [error, setError] = useState("");
  if (!editing) return <div className="editable-name"><strong>{value}</strong><button type="button" className="icon-button" aria-label={`Rename ${label}`} onClick={() => { setDraft(value); setError(""); setEditing(true); }}><Pencil size={14} aria-hidden="true" />Rename</button></div>;
  return <form className="name-editor" onSubmit={async event => {
    event.preventDefault(); if (busy || !draft.trim()) return;
    setBusy(true); setError("");
    try { await onSave(draft.trim()); setEditing(false); } catch { setError("Name could not be saved. Try again."); } finally { setBusy(false); }
  }}>
    <label htmlFor={id}>{label} name</label>
    <div className="name-editor-controls"><input id={id} name="displayName" value={draft} onChange={event => setDraft(event.target.value)} maxLength={120} required autoFocus disabled={busy} />
      <button type="submit" className="secondary-button" disabled={busy || !draft.trim()}>{busy ? "Saving…" : "Save"}</button>
      <button type="button" className="secondary-button" disabled={busy} onClick={() => setEditing(false)}>Cancel</button></div>
    {error && <p role="alert">{error}</p>}
  </form>;
}
